<template>
    <u-textarea-solo-rounded v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-textarea-solo-rounded>
</template>

<script>
import UTextareaSoloRounded from "@/components/publish/styles/forms/u-textarea-solo-rounded.vue";

export default {
    props: {},
    components: {
        UTextareaSoloRounded,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
